<template>
  <div class="lg:px-20 md:px-12 px-5 lg:py-8 md:py-6 py-4">
    <!-- <router-link to="/podcast-seasonpage"> -->
    <button
      v-if="getAllEpisode.result.length"
      class="flex items-center sm-fsize14 text-white bg-primary py-2 px-4 rounded-md mb-6"
      @click="handleRedirect()"
    >
      <feather-icon
        icon="ArrowLeftIcon"
        class=""
        svgClasses="w-4 h-4 mr-1"
      ></feather-icon>
      Go Back
    </button>
    <!-- </router-link> -->

    <!-- <div class="container flex center">
      <div class="lg:w-3/5 w-full mb-8">
        <img
          src="https://nexuscluster.blob.core.windows.net/server01/default/images/default2.jpg"
          alt="img"
          class="h-96 w-auto rounded-xl"
        />
      </div>
      <div class="lg:w-2/5 w-full mb-8">
        <p class="fsize40 md-fsize28 sm-fsize18 clr-black font-semibold pb-2">
          {{ SelectedVideo.title }}
        </p>
        <p class="fsize20 sm-fsize14">
          {{ SelectedVideo.description }}
        </p>
      </div>
    </div> -->
    <div class="lg:flex lg:gap-10 md:gap-6">
      <div class="lg:w-8/12 w-full lg:mb-0 md:mb-8 mb-8">
        <!-- <iframe
          class="h-500px md-h-450px sm-h-250px w-full rounded-xl object-contain"
          :src="SelectedVideo ? SelectedVideo.link : null"
          title="Spotify podcast player"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          id="chintan"
          ></iframe> -->
        <div class="h-min w-full rounded-xl lg:py-6 md:py-6 py-4">
          <iframe
            style="border-radius: 10px"
            :src="embedLink(SelectedVideo.link)"
            class="w-full custom-height"
            frameborder="0"
            scrolling="no"
          ></iframe>
          <!-- <iframe
              style="height: 185px; padding-bottom: 10px"
              :src="embedLink(SelectedVideo.link)"
              class="w-full lg:pt-6 md:pt-6"
              scrolling="no"
              frameborder="0"
              allowfullscreen=""
              allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
              loading="lazy"
            ></iframe> -->
        </div>
        <p class="fsize24 sm-fsize20 font-semibold text-black">
          {{ SelectedVideo.title }}
        </p>
        <p class="fsize18 sm-fsize14" v-html="SelectedVideo.description"></p>
      </div>
      <div
        class="lg:w-4/12 w-full lg:gap-6 md:gap-6 gap-4 overflow-auto h-90vh"
      >
        <!-- <img
          src="https://nexuscluster.blob.core.windows.net/server01/default/images/default2.jpg"
          alt="img"
          class="h-52 w-full rounded-xl "
        /> -->
        <div
          class="flex gap-4 mb-6 cursor-pointer"
          v-for="episode of getAllEpisode.result"
          :key="episode._id"
          @click="handleChange(episode)"
        >
          <!-- <iframe
            class="lg:h-48 md:h-48 h-44 w-1/2 rounded-xl"
            src="https://www.youtube.com/embed/_uQrJ0TkZlc"
            title="YouTube video player"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
          ></iframe> -->
          <img
            class="lg:h-32 md:h-32 h-28 w-1/2 rounded-xl object-cover"
            :src="`${$imageURL}/${episode.image}`"
            alt="img"
          />
          <div>
            <p class="fsize20 sm-fsize16 font-semibold text-black">
              {{ episode.title }}
            </p>
            <p class="fsize16-14 lineclamp-3" v-html="episode.description"></p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";

export default {
  data() {
    return {
      currentPage: 1,
      editModal: false,
      perPage: 5,
      search: "",
      totalPages: 0,
      SelectedVideo: null,
    };
  },
  watch: {},
  methods: {
    handleRedirect(id) {
      // this.$router.push({
      //   name: "podcast-seasonpage",
      //   query: {
      //     cid: id,
      //   },
      // });
      this.$router.go(-1);
    },
    async dataLoad() {
      let curPage = this.currentPage - 1;
      let payload = {
        // limit: this.perPage,
        // offset: curPage * this.perPage,
        // search: "",
        podcastId: this.$route.query.podcastId,
      };

      await this.$store.dispatch("podcast/getall_episode", payload);
      console.log(this.getAllEpisode);
      this.SelectedVideo = this.getAllEpisode.result.length
        ? this.getAllEpisode.result[0]
        : null;
      this.totalPages = this.getAllEpisode.totalCount;
    },
    handlePageChange(value) {
      this.currentPage = value;
      this.dataLoad();
    },
    handleFrame(url) {
      const regex =
        /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/;
      const match = url.match(regex);
      return `https://img.youtube.com/vi/${match[1]}/hqdefault.jpg`;
    },
    // async createHistory(SelectedVideo) {
    //   this.SelectedVideo = SelectedVideo;

    //   if (Object.keys(this.user).length <= 0) return;
    //   let payload = {
    //     episodeId: SelectedVideo._id,
    //   };
    //   try {
    //     await this.$store.dispatch("podcast/add_history", payload);
    //     this.dataLoad();
    //   } catch (error) {
    //     console.log(error);
    //   }
    // },
    embedLink(link) {
      if (link) {
        if (link.includes("embed")) {
          return link;
        }
        return link.replace(
          "/pod/show/caregiver-saathi/",
          "/pod/show/caregiver-saathi/embed/"
        );
      }
      return "";
    },
    handleChange(SelectedVideo) {
      this.SelectedVideo = SelectedVideo;
    },
  },
  computed: {
    ...mapState("podcast", { getAllEpisode: "getAllEpisode" }),
    ...mapState("auth", { user: "user" }),
  },
  mounted() {
    this.dataLoad();
    // console.log("Playvideos", this.getAllEpisode);
  },
};
</script>
<style>
.custom-height {
  height: 101px;
}
/* .container::-webkit-scrollbar {
  width: 8px;
}

.container::-webkit-scrollbar-thumb {
  background-color: #888;
  border-radius: 4px;
}

.container::-webkit-scrollbar-thumb:hover {
  background-color: #555;
}

.container::-webkit-scrollbar-track {
  background-color: #f1f1f1;
  border-radius: 4px;
} */
@media (min-width: 1369px) {
  .custom-height {
    height: 160px;
  }
}
</style>
